import React, { useState } from 'react';
import Icon from '../AppIcon';
import Button from './Button';

const RoleBasedHeader = ({ 
  userRole = 'patient', 
  userName = 'John Doe', 
  onLogout = () => {}, 
  onProfileClick = () => {} 
}) => {
  const [isProfileMenuOpen, setIsProfileMenuOpen] = useState(false);

  const handleLogout = () => {
    setIsProfileMenuOpen(false);
    
    // Clear authentication state
    localStorage.removeItem('isAuthenticated');
    localStorage.removeItem('userType');
    localStorage.removeItem('userName');
    localStorage.removeItem('userEmail');
    
    // Call the parent logout handler
    onLogout();
  };

  const handleProfileClick = () => {
    setIsProfileMenuOpen(false);
    onProfileClick();
  };

  return (
    <header className="fixed top-0 left-0 right-0 z-[1000] bg-card border-b border-border">
      <div className="flex items-center justify-between h-16 px-6">
        {/* Logo Section */}
        <div className="flex items-center">
          <div className="flex items-center space-x-3">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Icon name="Brain" size={20} color="white" />
            </div>
            <span className="text-xl font-semibold text-foreground">MycoMind</span>
          </div>
        </div>

        {/* User Section */}
        <div className="flex items-center space-x-4">
          {/* User Role Badge */}
          <div className="hidden sm:flex items-center space-x-2 px-3 py-1 bg-muted rounded-full">
            <Icon 
              name={userRole === 'provider' ? 'Stethoscope' : 'User'} 
              size={16} 
              color="var(--color-muted-foreground)" 
            />
            <span className="text-sm font-medium text-muted-foreground capitalize">
              {userRole}
            </span>
          </div>

          {/* User Profile Dropdown */}
          <div className="relative">
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsProfileMenuOpen(!isProfileMenuOpen)}
              className="flex items-center space-x-2 px-3"
            >
              <div className="w-8 h-8 bg-primary/10 rounded-full flex items-center justify-center">
                <Icon name="User" size={16} color="var(--color-primary)" />
              </div>
              <span className="hidden md:block text-sm font-medium text-foreground">
                {userName}
              </span>
              <Icon 
                name="ChevronDown" 
                size={16} 
                className={`transition-transform duration-150 ${isProfileMenuOpen ? 'rotate-180' : ''}`}
              />
            </Button>

            {/* Dropdown Menu */}
            {isProfileMenuOpen && (
              <div className="absolute right-0 top-full mt-2 w-48 bg-popover border border-border rounded-lg shadow-soft-md animate-fade-in">
                <div className="py-2">
                  <div className="px-4 py-2 border-b border-border">
                    <p className="text-sm font-medium text-foreground">{userName}</p>
                    <p className="text-xs text-muted-foreground capitalize">{userRole} Account</p>
                  </div>
                  
                  <button
                    onClick={handleProfileClick}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                  >
                    <Icon name="Settings" size={16} />
                    <span>Profile Settings</span>
                  </button>
                  
                  {userRole === 'provider' && (
                    <button
                      onClick={() => setIsProfileMenuOpen(false)}
                      className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                    >
                      <Icon name="Shield" size={16} />
                      <span>Admin Panel</span>
                    </button>
                  )}
                  
                  <button
                    onClick={() => setIsProfileMenuOpen(false)}
                    className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-foreground hover:bg-muted transition-colors duration-150"
                  >
                    <Icon name="HelpCircle" size={16} />
                    <span>Help & Support</span>
                  </button>
                  
                  <div className="border-t border-border mt-2 pt-2">
                    <button
                      onClick={handleLogout}
                      className="w-full flex items-center space-x-2 px-4 py-2 text-sm text-destructive hover:bg-destructive/10 transition-colors duration-150"
                    >
                      <Icon name="LogOut" size={16} />
                      <span>Sign Out</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* Click outside to close dropdown */}
      {isProfileMenuOpen && (
        <div 
          className="fixed inset-0 z-[-1]" 
          onClick={() => setIsProfileMenuOpen(false)}
        />
      )}
    </header>
  );
};

export default RoleBasedHeader;